<template>
  <modal :show="show" @close="close">
    <v-flex slot="title">{{ !!id ? 'Edytuj profil' : 'Dodaj urzędnika' }}</v-flex>

    <profile-form :schema="$schema" :edit="!!id" :simple="true" :show="show"></profile-form>

    <v-layout slot="actions">
      <v-spacer></v-spacer>

      <v-btn color="error" flat @click="close">Anuluj</v-btn>

      <v-btn color="success" flat @click="save">Zapisz</v-btn>
    </v-layout>
  </modal>
</template>

<script>
import { mapState } from 'vuex';
import { WSchema } from '@witkac/vuetify-components';
import { ProfileType } from '@witkac/kartamiejska-shared';

import schema from '@/schemas/official.schema';
import modal from '@/components/material/Modal';
import ProfileForm from '../../profile/ProfileForm';
import { manageMixin } from '@/mixins/manage';

const emptyData = () => ({
  login: '',
  profile: {
    firstName: '',
    lastName: '',
    type: ProfileType.OFFICIAL,
    email: '',
    mainImage: null
  }
});

// @vuese
// Modal dodawnia/edycji profilu urzędnika
// @group Officials-Profile
export default {
  components: { modal, ProfileForm },
  mixins: [manageMixin('officials', {}, emptyData)],
  schema,
  props: {
    id: { type: String, required: false }
  },
  methods: {
    getId() {
      return this.stateData.profile.id;
    },
    // @vuese
    // aktualizacja profilu urzędnika
    update() {
      this.model.profile.userId = this.id;
      this.$emit('update', {
        id: this.getId(),
        ...this.model
      });
    }
  }
};
</script>
